// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1518U","footer":"styles_footer__1p8c0","passCodeTooltip":"styles_passCodeTooltip__2Z8Ti"};